import styled, { css } from "styled-components";

export const StyledCard = styled.div<{
  $clickable?: boolean;
  $active?: boolean;
}>`
  display: flex;
  flex-direction: column;
  gap: 0;
  padding: ${({ theme }) => theme.padding.small};
  margin: 0;
  border: 2px solid transparent;
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: ${({ theme }) => theme.shadow.large};
  width: 100%;
  transition: border-color 0.15s ease, background-color 0.15s ease,
    box-shadow 0.15s ease;

  ${({ $clickable }) =>
    $clickable &&
    css`
      cursor: pointer;
      user-select: none;

      &:hover {
        border-color: ${({ theme }) => theme.colors.borderColor};
      }

      &:focus-visible {
        outline: none;
        border-color: ${({ theme }) => theme.colors.primary};
      }
    `}

  ${({ $active }) =>
    $active &&
    css`
      border-color: ${({ theme }) => theme.colors.primary};
      background-color: ${({ theme }) => theme.colors.primaryLight};
    `}
`;

export const StyledIconContainer = styled.div`
  display: flex;
  justify-content: end;
`;
